import './skip_link_for_element.less';

import React, { Component, Fragment } from 'react';

class SkipLinkForElement extends Component {

  constructor() {
    super();

    // the odds of a collision are low enough for a single page render so this is okay
    this.skipLinkId = Math.floor(Math.random()*1000000);
  }

  render() {
    const { skipLinkText, children } = this.props;

    const id = `skip-link-target-${this.skipLinkId}`;

    return (
      <Fragment>
        <a href={`#${id}`} className="skip-link-for-element">
          { skipLinkText }
        </a>

        { children }

        <div id={id} tabIndex="0" />
      </Fragment>
    );
  }

}

const ConditionalSkipLinkForElement = ({ shouldShowSkipLink, children, ...props })=> (
  shouldShowSkipLink ?
    <SkipLinkForElement children={children} { ...props } />
  :
    children
);

export { ConditionalSkipLinkForElement };

export default SkipLinkForElement;
